module.exports = __webpack_public_path__ + "static/media/soul-pastor.d8a7f6f1.jpg";